exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-1a4b1d3d] {\n  padding-bottom: 10px;\n}\n.filter-item[data-v-1a4b1d3d] {\n  margin-right: 10px;\n}\n.sub-text[data-v-1a4b1d3d] {\n  font-size: 12px;\n  color: #909399;\n  margin-top: 2px;\n}\n", ""]);

// exports
